/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationChoice/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function LocationChoice({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Treatments/Content/Treatment/LocationChoice",
  onChange
  
}) {
let patientLocationsValueData = fromData.useDataValue({ viewPath,
context: 'patient_locations',
})
let profilePatientTxOrganizationIdValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient_tx',
path: 'organization_id',
})
let profilePatientTxOrganizationIdChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient_tx',
path: 'organization_id',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 field="name"
 marginTop={0}
 data="patient_locations"
 from={patientLocationsValueData}
 data="profile_patient_tx.organization_id"
 value={profilePatientTxOrganizationIdValueData}
 onChange={profilePatientTxOrganizationIdChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}